export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7144.db02a29c.jpg";